import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';

import OrdersPage from './OrdersPage';
import CreateOrderPage from './CreateOrderPage';
import EditOrderPage from './EditOrderPage';
import OrderPage from './OrderPage';
import AssignOrderPage from './AssignOrderPage';
import FulfillOrderForm from './FulfillOrderForm';
import CloseOrderPage from './CloseOrderPage';
import RollbackOrderPage from './RollbackOrderPage';

import CurrentFBO from '../../Services/CurrentFBO';


const Order = ({ match, history, location }) => {
  return (
    <div>
      <Switch>
        <Route path={`${match.url}/create`} render={() => (<CreateOrderPage fboId={CurrentFBO.getId()} history={history} />)} />
        <Route path={`${match.url}/:orderId/edit`} render={props => (<EditOrderPage fboId={CurrentFBO.getId()} {...props} />)} />
        <Route path={`${match.url}/:orderId/assign`} render={props => (<AssignOrderPage fboId={CurrentFBO.getId()} {...props} />)} />
        <Route path={`${match.url}/:orderId/fulfill`} render={props => (<FulfillOrderForm fboId={CurrentFBO.getId()} {...props} />)} />
        <Route path={`${match.url}/:orderId/close`} render={props => (<CloseOrderPage fboId={CurrentFBO.getId()} {...props} />)} />
        <Route path={`${match.url}/:orderId/rollback`} render={props => (<RollbackOrderPage fboId={CurrentFBO.getId()} {...props} />)} />
        <Route path={`${match.url}/:orderId`} render={props => (<OrderPage fboId={CurrentFBO.getId()} {...props} />)} />
        <Route exect path={`${match.url}`} render={props => (<OrdersPage fboId={CurrentFBO.getId()} {...props} />)} />
      </Switch>
    </div>
  );
};

export default Order;



// WEBPACK FOOTER //
// ./src/Containers/Orders/OrdersRoutes.js